import React, {Dispatch, KeyboardEvent, RefObject, SetStateAction} from 'react'
import TextField from '@mui/material/TextField'

interface SerialInputProps {
    currentSerial: string
    setCurrentSerial: Dispatch<SetStateAction<string>>
    handleKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void
    inputRef: RefObject<HTMLInputElement>
    sampleSerialItems?: {sku?: any; bin?: any}[]
    selectedIndex?: number
    basicLabel?: string
    placeholder?: string
    disabled?: boolean
}

export const SerialInput = (props: SerialInputProps) => {
    const {
        currentSerial,
        setCurrentSerial,
        handleKeyDown,
        inputRef,
        sampleSerialItems = [],
        selectedIndex = -1,
        basicLabel = 'Scan or Type Serial',
        placeholder = 'Scan or enter a serial number',
        disabled = window.sessionStorage.getItem('blocking') === 'true'
    } = props

    const label = selectedIndex >= 0 && sampleSerialItems[selectedIndex]
        ? `${basicLabel} ${sampleSerialItems[selectedIndex]?.sku ? `for ${sampleSerialItems[selectedIndex].sku}` : ''} ${sampleSerialItems[selectedIndex]?.bin ? `(${sampleSerialItems[selectedIndex].bin})` : ''}`
        : basicLabel

    return (
        <TextField
            label={label}
            variant="outlined"
            fullWidth
            margin="normal"
            value={currentSerial}
            onChange={e => setCurrentSerial(e.target.value.trim())}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            disabled={disabled}
            inputRef={inputRef}
        />
    )
}
